<div class="banner-message-main" >
    <div *ngIf="displayBannerMessage" id="banner-message" class="col-sm-12" [innerHTML]="bannerMessageContentHTML">
    </div>
</div>
